import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import InputPhoneCommon from '../../../CommonV2/InputPhone';

/**
 * FieldInputPhone
 * @param {*} param0
 */
const FieldInputPhone = ({ code, disabled, validate, existError, showError, handleBlur }) => (
  <Field
    component={InputPhoneCommon}
    name={code}
    disabled={disabled}
    validate={validate}
    existError={existError}
    showError={showError}
    eventEmitter={v => handleBlur(v)}
  />
);

FieldInputPhone.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
};
FieldInputPhone.defaultProps = {
  disabled: false,
};

export default connect(FieldInputPhone);
